import {
  LOAD_AUDIENCES_REQUESTED,
  LOAD_AUDIENCES_OK,
  LOAD_AUDIENCES_FAIL,
  CREATE_AUDIENCES_FAIL,
} from "actions/audiences";
import {
  CREATE_AUDIENCES_REQUESTED,
  UPDATE_AUDIENCES_COUNT_OK,
  UPDATE_AUDIENCES_COUNT_REQUEST,
} from "../actions/audiences";

const INITIAL_STATE = {
  loading: false,
  data: {},
  audiences: [],
  error: false,
  counts: [],
  countsLoading: false,
};

export function audiencesReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case LOAD_AUDIENCES_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case CREATE_AUDIENCES_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case CREATE_AUDIENCES_FAIL:
      return {
        ...state,
        loading: false,
      };

    case LOAD_AUDIENCES_OK:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.data,
        audiences: action.data.audiencesList.audiences || [],
      };

    case LOAD_AUDIENCES_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
      };

    case UPDATE_AUDIENCES_COUNT_OK:
      return {
        ...state,
        countsLoading: false,
        error: false,
        counts: action.data,
      };
    case UPDATE_AUDIENCES_COUNT_REQUEST:
      return {
        ...state,
        countsLoading: true,
      };
    default:
      return state;
  }
}
// UPDATE_AUDIENCES_COUNT_REQUEST
